var React = require('react');

function Ellipse (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M240 239C240 207.745 233.818 176.797 221.807 147.921C209.796 119.046 192.192 92.8089 169.998 70.7086C147.805 48.6082 121.458 31.0773 92.4613 19.1167C63.4645 7.15605 32.3859 0.999999 1 1","stroke":"#EEEEEE","strokeOpacity":"1","strokeLinecap":"round"}));
}

Ellipse.defaultProps = {"width":"241","height":"240","viewBox":"0 0 241 240","fill":"none"};

module.exports = Ellipse;

Ellipse.default = Ellipse;
